var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('el-button',{staticStyle:{"width":"100%","height":"50px","font-size":"30px"},attrs:{"type":"primary","size":"medium ","icon":"el-icon-link"},on:{"click":function($event){return _vm.openlink()}}},[_vm._v("打开链接")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20412367","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutExtralPageNoFrame.vue
// module id = null
// module chunks = 